module.exports = __webpack_public_path__ + "media/images/logout_ic-aa14f5adecf34e0c81e7b5c9b10d135c.svg";